const normalizeSearchText = (value) => String(value || '')
  .toLowerCase()
  .normalize('NFKD')
  .replace(/[\u0300-\u036f]/g, '')
  .replace(/[\s.,/#!$%^&*;:{}=\-_`~()[\]"'\\|+?<>@]+/g, ' ')
  .trim();

export const productMatchesSearch = (product, query) => {
  const searchTerms = normalizeSearchText(query).split(' ').filter(Boolean);
  if (searchTerms.length === 0) return true;

  const searchableText = normalizeSearchText([
    product.name,
    product.brand,
    product.brandName,
    product.category,
    product.subcategory
  ].filter(Boolean).join(' '));

  return searchTerms.every(term => searchableText.includes(term));
};
